
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/steel-wheels",
      function () {
        return require("private-next-pages/rims/steel-wheels.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/steel-wheels"])
      });
    }
  